import React, { Component } from 'react';
import { motion } from 'framer-motion';
import { Image, Map, Mountain, Church, Navigation, Landmark, Globe, Waves, Building2, Plane, BookOpen, MapPin, Cloud, Route, Compass, Crown, Tent, BoxIcon } from 'lucide-react';
export function VisualContentGrid() {
  const items = [{
    label: 'El Jardín del Edén y Mesopotamia',
    icon: Mountain
  }, {
    label: 'La Ruta del Éxodo',
    icon: Route
  }, {
    label: 'El Tabernáculo en el Desierto',
    icon: Tent
  }, {
    label: 'La Conquista de Canaán',
    icon: Landmark
  }, {
    label: 'Jerusalén en la época de David',
    icon: Navigation
  }, {
    label: 'El Templo de Salomón (3D)',
    icon: Building2
  }, {
    label: 'Los Reinos Divididos',
    icon: Crown
  }, {
    label: 'El Exilio en Babilonia',
    icon: Landmark
  }, {
    label: 'Tierra Santa en tiempos de Jesús',
    icon: Globe
  }, {
    label: 'El Mar de Galilea',
    icon: Waves
  }, {
    label: 'Jerusalén en el siglo I',
    icon: Church
  }, {
    label: 'Los Viajes Misioneros de Pablo',
    icon: Plane
  }, {
    label: 'Las 7 Iglesias de Apocalipsis',
    icon: BookOpen
  }, {
    label: 'Reconstrucciones 3D de Ciudades',
    icon: BoxIcon
  }, {
    label: 'Mapas Topográficos Detallados',
    icon: Map
  }, {
    label: 'Clima y Vegetación por Región',
    icon: Cloud
  }, {
    label: 'Rutas Comerciales Antiguas',
    icon: Compass
  }, {
    label: 'Sitios Arqueológicos Verificados',
    icon: MapPin
  }];
  return <section className="py-8 md:py-16 bg-navy-900 text-white content-section" data-id="element-387">
      <div className="max-w-6xl mx-auto px-4 sm:px-6" data-id="element-388">
        <div className="text-center mb-6 md:mb-12" data-id="element-389">
          <h2 className="font-heading text-2xl md:text-4xl font-bold text-gold-300 mb-4" data-id="element-390">
            Tipos de Contenido Visual{' '}
            <span className="text-white highlight-burgundy" data-id="element-391">
              Que Explorarás Hoy
            </span>
          </h2>
          <p className="text-gray-400 max-w-2xl mx-auto text-base md:text-lg" data-id="element-392">
            Una colección{' '}
            <span className="font-bold text-gray-200" data-id="element-393">exhaustiva</span> diseñada
            para cubrir{' '}
            <span className="italic text-gold-200" data-id="element-394">
              cada aspecto geográfico y visual
            </span>{' '}
            de las Escrituras.
          </p>
        </div>

        <div className="grid grid-cols-1 sm:grid-cols-2 lg:grid-cols-3 gap-2.5 md:gap-4" data-id="element-395">
          {items.map((item, index) => {
          const IconComponent = item.icon;
          return <motion.div key={index} initial={{
            opacity: 0,
            scale: 0.95
          }} whileInView={{
            opacity: 1,
            scale: 1
          }} viewport={{
            once: true,
            margin: '-50px'
          }} transition={{
            delay: Math.min(index * 0.05, 0.3),
            duration: 0.3
          }} className="flex items-center p-3 md:p-4 bg-navy-800 rounded-lg border border-navy-700 hover:border-gold-600/50 transition-colors duration-200 will-change-transform" data-id="element-396">
                <div className="mr-2 p-1.5 md:mr-3 md:p-2 bg-navy-900 rounded-full border border-navy-600 flex-shrink-0" data-id="element-397">
                  <IconComponent className="w-4 h-4 md:w-5 md:h-5 text-gold-600" data-id="element-398" />
                </div>
                <span className="text-gray-200 font-medium text-sm md:text-base" data-id="element-399">
                  {item.label}
                </span>
              </motion.div>;
        })}
        </div>

        <div className="mt-4 md:mt-8 text-center" data-id="element-400">
          <p className="text-gold-400 font-bold text-xl tracking-wide" data-id="element-401">
            ¡Y Mucho Más!
          </p>
        </div>
      </div>
    </section>;
}